import * as types from '@/mutation-types';
import { IProfileModel, ISnackBar } from '@/models/Common';
import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import Api from '@/Api';
import { IRootState, IAppState } from '@/models/State';

const initState: IAppState = {
    drawer: true,
    profile: {} as any,
    snackBar: {
        show: false,
        text: '',
    },
};

const getters: GetterTree<IAppState, IRootState> = {
    userProfile: (state) => state.drawer,
    role: (state) => state.profile.role,
    initial: (state) => state.profile.name && state.profile.name!.charAt(0),
    name: (state) => state.profile.name,
    snackBar: (state) => state.snackBar,
    empId: (state) => state.profile.empId,
    doj: (state) => state.profile.doj
};

const mutations: MutationTree<IAppState> = {
    [types.UPDATE_PROFILE](state, payload: IProfileModel) {
        state.profile = payload;
    },
    [types.SNACK_BAR](state, payload: ISnackBar) {
        state.snackBar = payload;
    },
};

const actions: ActionTree<IAppState, IRootState> = {
    getUserProfile({commit}): any {
        return new Promise((resolve, reject) => {
            Api.Instance
            .get('/api/user-profile')
            .then((response) => {
                commit(types.UPDATE_PROFILE, response.data);
                resolve(response.data);
            }, (error) => {
                reject(error);
            });
        });
    },
};

const namespaced: boolean = true;

export const AppStore: Module<IAppState, IRootState> = {
    namespaced,
    state: initState,
    getters,
    mutations,
    actions,
};
